import React from "react";
import { Navigate } from "react-router-dom";
import { getAuthToken } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const token = getAuthToken();
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}
